import { HTTP } from '../../utils'

export const getAdvisees = (page, count, name, sort) => {
  let url = 'user/advisees?name=' + name + '&page=' + page + '&count=' + count
  if (sort) {
    url = url + '&sort=' + sort
  }
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const getAllAdviseesMinInfo = (page, count, name, sort) => {
  let url = 'user/all/advisees?name=' + name + '&page=' + page + '&count=' + count
  if (sort) {
    url = url + '&sort=' + sort
  }
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const doCsvUploadForAdviseeAdvisors = (institutionId, createdByUuid, fileData) => {
  if (!institutionId || !createdByUuid) {
    return
  }
  let url = '/user/adviseeAdvisorUpload/' + institutionId + '?createdByUuid=' + createdByUuid
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const requestAccessToPlanningStream = (userId) => {
  // NOTE: this was throwing 404 because I believe the endpoint is called 'requestAccessToStream'
  return HTTP().post('/entity/requestAccessToPlanningStream/' + userId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createOrUpdateCalendarEvent = (data) => {
  let url = '/calendarEvent'
  if (data.uuid) {
      url += '/' + data.uuid
  }
  return HTTP().put(url, data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getAllCalendarEvents = () => {
  return HTTP().get('/calendarEvent/fetchAll')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getNamedQueries = () => {
  return HTTP().get('/nameQuery/institution')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const getExportNamedQueriesToCsv = (queryId, tags) => {
  return HTTP().get('/nameQuery/csv/export/advisee?queryId='+queryId+'&tags='+tags)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const manualRelease = (uuid, status) => {
  return HTTP().put('entity/' + uuid + '/release?status='+status)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const manualWaive = (uuid, details, score, status) => {
  return HTTP().put('entity/' + uuid + '/waive?details='+details+'&score='+score+'&status='+status)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const overrideCourse = (uuid, score) => {
  return HTTP().put('entity/' + uuid + '/override?score='+score)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const unenrollUserFromProgram = (userId, programCode) => {
  return HTTP().put('user/unenroll/program/' + programCode + '/user/'+userId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const reProcessEnrollmet = (userId, programCode) => {
  return HTTP().put('user/fix/program/' +userId+'/'+ programCode)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const getCalendarEventsForParticipants = (userUuids) => {
  return HTTP().put('/calendarEvent/fetchByParticipant', userUuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getFutureCalendarEventsForParticipant = (participantId) => {
  return HTTP().get('/calendarEvent/nextCalendarEvent/participant/' +  participantId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const deleteCalendarEvent = (uuid) => {
  return HTTP().delete('/calendarEvent/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getPersonProfilesForSelectedUsers = (uuids) => {
  return HTTP().put('user/personProfilesForSelectedUsers', uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getPersonTags = (userId) => {
  return HTTP().get('person/personTagsByUserId/' + userId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getAdviseesPersonTags = () => {
  return HTTP().get('person/getAdviseesPersonTags')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}

export const getAdviseeDetail = (uuid) => {
  return HTTP().get('user/adviseeDetail/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error: ' + e)
  })
}



// WEBPACK FOOTER //
// ./src/app/adviseeTracker/api.js